import { Icon } from '@/components/Icon';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

interface NoAccessProps {
  email: string | undefined;
  requestId: string | undefined;
  onSignOut: () => void;
}

/**
 * The API refused the signed-in identity (`GET /me` answered 401/403): no Hangar user for it, no membership, or an
 * account already linked to another sign-in. Without this page the shell kept its skeletons forever.
 */
export function NoAccess({ email, requestId, onSignOut }: NoAccessProps) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6">
      <Card role="alert" data-testid="no-access" className="w-full max-w-[440px] rounded-xl p-6 shadow-overlay">
        <Logo height={24} />
        <div className="mt-5 flex items-start gap-3">
          <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-destructive/30 bg-destructive/10 text-destructive">
            <Icon name="error" size={22} />
          </span>
          <div className="min-w-0">
            <h1 className="text-base font-semibold text-foreground">This account has no access to Hangar</h1>
            <p className="mt-1 text-[13px] text-muted-foreground">
              {email ? <span className="break-all font-medium text-foreground">{email}</span> : 'The account you signed in with'} is not a member of any
              organization, or is linked to a different sign-in. Sign in with the account your invitation was sent to, or ask
              your organization admin for an invitation.
            </p>
            {requestId ? <p className="mt-2 font-mono text-xs text-muted-foreground">{requestId}</p> : null}
          </div>
        </div>
        <Button data-testid="no-access-sign-out" className="mt-6 min-h-11 w-full" onClick={onSignOut}>
          Sign out and use another account
        </Button>
      </Card>
    </div>
  );
}
